/**
 * Sync s DB (Epic 2) — staví na diff enginu z `diff.ts` (Epic 3), který se
 * beze změny reužívá i tady: `compareSchemaModels(model, rescanned)` už dává
 * přesně `dbToModel` sémantiku (epic-2 kap. 6 — "removed = objekt je v
 * modelu, ale chybí v DB"), když se jako "old" předá aktuální model a jako
 * "new" čerstvě naskenovaný stav DB.
 *
 * `path` u `DiffItem` je čistě popisný text ("schema.tabulka[.položka]") —
 * dřív se nikdy neparsoval zpátky (Epic 3 diff jen zobrazuje, nic z něj
 * neaplikuje). Epic 2 je první konzument, který z něj potřebuje odvodit
 * KONKRÉTNÍ objekt k mergi; `findTableForPath` to dělá bez slepého split('.')
 * (jméno tabulky/sloupce teoreticky může tečku obsahovat) tak, že hledá,
 * která tabulka ze seznamu je skutečně prefixem cesty.
 */
import { compareSchemaModels } from './diff.js';
/** `renamed` (Epic 9) se chová jako `added`/`changed` — jen `removed` je ve výchozím výběru odškrtnuté. */
export function defaultSyncItemSelection(item) {
    return item.changeType !== 'removed';
}
/**
 * Stabilní identifikátor položky v rámci jednoho diffu — pro checkboxy a výběr
 * v UI i pro server-side filtrování vybraných položek (Epic 9,
 * `GenerateChangeScriptRequest.selectedKeys`). `changeType` je součástí klíče
 * záměrně (ne jen `objectType:path`) — přejmenovaná tabulka/sloupec (Epic 9,
 * `detectRenames`) může na STEJNÉ cestě nést i samostatnou `changed` položku
 * (jiná vlastnost se změnila zároveň), a ty dvě musí mít odlišný klíč.
 */
export function diffItemKey(item) {
    return `${item.objectType}:${item.changeType}:${item.path}`;
}
/**
 * E2-US1/US2 — diff mezi aktuálním modelem a čerstvě naskenovaným stavem DB,
 * doplněný o výchozí granulární výběr (E2-US3). Sdílí `compareSchemaModels`
 * s Epic 3 (epic-2 kap. 8 — "jeden diff engine, ne dva").
 */
export function buildSyncDiff(model, rescanned) {
    return compareSchemaModels(model, rescanned).map((item) => ({
        ...item,
        selected: defaultSyncItemSelection(item),
    }));
}
/**
 * Najde tabulku (a případně jméno dílčí položky v ní), ke které `DiffItem.path`
 * patří, uvnitř DANÉHO seznamu tabulek (volající předá `model.tables` pro
 * `removed`/starou stranu `changed`, `rescanned.tables` pro `added`/novou
 * stranu `changed`). Vrací `null`, pokud cesta neodpovídá žádné tabulce v
 * daném seznamu (typicky proto, že volající sáhl do nesprávné strany).
 */
export function findTableForPath(tables, path) {
    for (const table of tables) {
        const key = `${table.schema}.${table.name}`;
        if (path === key)
            return { table, itemName: null };
        if (path.startsWith(`${key}.`))
            return { table, itemName: path.slice(key.length + 1) };
    }
    return null;
}
//# sourceMappingURL=sync.js.map